export default "__VITE_ASSET__B3eHYE4h__"